import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "detail_content" }

import { reactive, toRefs, ref } from "vue";
import Form from "./form.vue";
import Nav from "./nav.vue";
import { getAesStr } from "@/config/request";
import { AREA_ID,AREA_NAME, FORM_URL } from "@/config/const";
import { ElMessage } from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    publicData:{} as any
},
  setup(__props, { expose: __expose }) {

const props = __props
const data = reactive({
    itemList:[] as any,
})
const form = ref(null) as any
const { publicData } = toRefs(props) as any
console.log('publicData:::::',publicData?.value)
//  验证字段以及保存第一步的数据
const check = async() => {
    let status = 200
    const formData = form.value.getFormData()

    formData.basicInfo.preExpress.projid = formData.basicInfo.preApasinfo.projid
    formData.basicInfo.preExpress.belongsystem = formData.basicInfo.preApasinfo.belongsystem
    formData.basicInfo.preExpress.areacode = formData.basicInfo.preApasinfo.areacode
    formData.basicInfo.preExpress.extend = 'I'
    formData.basicInfo.preExpress.syncStatus = 'I'
    formData.basicInfo.preExpress.dataversion = '1'
    formData.basicInfo.preExpress.createTime = formData.basicInfo.preApasinfo.createTime
    
    formData.basicInfo.preApasinfoRelation.isJgyd = formData.basicInfo.preApasinfoRelation.isJgydStatus?'1':'0'
    const receiveAddr = formData.basicInfo.preExpress.receiveProvince + formData.basicInfo.preExpress.receiveCity +
        formData.basicInfo.preExpress.receiveCounty + '/' + formData.basicInfo.preExpress.receiveAddr
    formData.basicInfo.preExpress.receiveAddr = receiveAddr
    
    let formUrl = FORM_URL + '?'
    let obj = {
        formId: formData.formJson.formId,
        projid: formData.basicInfo.preApasinfo.projid,
        applyCardnumber: formData.basicInfo.preApasinfo.applyCardnumber,
        serviceCode: formData.basicInfo.preApasinfo.servicecode,
        areaCode: AREA_ID,
        applyname: formData.basicInfo.preApasinfo.applyname,
        applyCardtype: formData.basicInfo.preApasinfo.applyCardtype,
        contactman: formData.basicInfo.preApasinfo.contactman,
        telphone: formData.basicInfo.preApasinfo.telphone,
        contactCardType: formData.basicInfo.preApasinfo.contactCardType,
        contactmanCardnumber: formData.basicInfo.preApasinfo.contactmanCardnumber,
        corpName:formData.basicInfo.preApasinfo.corpName,
    };
    const res = await getAesStr({paramData: JSON.stringify(obj)}) as any
    console.log('加密返回值：', res);
    if (res.code === 0) {
        formUrl += `jm=${res.result}`;
        formData.formUrl = formUrl
        formData.jmFormData = '';
    }else {
        //alert("事项获取表单失败！")
    }
    if(formData.basicInfo.preApasinfo.contactman === '' ||
        formData.basicInfo.preApasinfo.telphone === '' ||
        formData.basicInfo.preApasinfo.contactmanCardnumber === ''
    ){
        status = 500
        ElMessage.error('请完整填写申报信息')
    }

    let result = {
        data:formData,
        status: status
    }
    return result
}

__expose({
    check,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Nav),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t6_title_h2" }, "申请人信息", -1)),
        _createVNode(Form, {
          ref_key: "form",
          ref: form,
          publicData: _unref(publicData)
        }, null, 8, ["publicData"])
      ])
    ])
  ], 64))
}
}

})